import { Component, Input, Host } from '@angular/core';
import { IUploadFile } from "../../../../common/services/document-management.service";
import { FileUploadComponent } from '../file-upload.component';

@Component({
    selector: 'file-upload-item',
    templateUrl: './file-upload-item.component.html',
    styleUrls: ['./file-upload-item.component.scss'],
    host: {
        style: 'width:100%;'
    },
    standalone: false
})
export class FileUploadItemComponent {
    @Input()
    file: IUploadFile;

    @Input() allowDeletion: boolean;

    constructor(
        @Host() public fileUploadComponent: FileUploadComponent
    ) { }

    public uploadFile(): void {
        this.fileUploadComponent.uploadFile(this.file).subscribe(() => {
            this.file.completed = true;
            this.fileUploadComponent.validateControl();
        },
            (err) => {
                this.file.completed = false;
                this.file.isUploading = false;
                this.file.error = err;
                this.fileUploadComponent.validateControl();
            });
    }

    public deleteFile(): void {
        this.fileUploadComponent.deleteFile(this.file);
    }
    public downloadFile(): void {
        this.fileUploadComponent.downloadFile(this.file);
    }
}
